export const customizeSideBar = {
    mainbox:{
        width:'50px',
        height:'50px',
        borderRadius: '50%',
        background: 'blue',
        position: 'fixed',
        right: '40px',
        zIndex: '2',
        bottom:'20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        cursor:'pointer'
    },
    customizeSideBar:{
        width: '300px',
    },
    top:{
        padding: '10px 5px'
        // padding:''
    },
    smartbox:{
        padding:'15px',
        border: '1px solid gray',
        borderRadius: '20px',
        margin: '10px 5px',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer'
    },
    icon:{
        fontSize: '25px',
        marginRight: '10px',
        marginBottom: '-7px'
    },
    input:{
        position:'absolute',
        opacity: '0'
    },
    colorBox:{
        blue: {
            background: 'blue',
            width:'20px',
            height:'20px',
            display:'flex',
            justifyContent: 'center',
            borderRadius: '4px'
        }
    }
}